import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { json, useParams } from "react-router-dom";
import { ToTimeJalali } from "../../../Common/Function/index";
import Loading from "../../../Common/Components/Loading";
import { GetTicket, FormChatSubmit } from "./Components/Services";
import { Spinner } from "react-bootstrap";

function Chating() {
  const { id } = useParams();
  const { user } = useSelector(state => state);
  const isApp = JSON.parse( localStorage.getItem('isApp'))

  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
    form: {
      ticket_id: id,
      description: "",
      attach: null,
    },
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    Handler();
  }, []);
  const Handler = () => {
    setState({ ...state, loading: true });
    GetTicket(id).then(result => {
      setState({
        ...state,
        loading: false,
        data: result,
      });
    });
  };

  const SendMessage = () => {
    setState({ ...state, loadbtn: true });
    FormChatSubmit(state.form).then(res => {
      if (res) {
        setState({
          ...state,
          form: { ...state.form, description: "", attach: null },
          data: res,
          loadbtn: false,
        });
      } else {
        setState({ ...state, loadbtn: false });
      }
    });
  };
  function UserChat({ data }) {
    return (
      <div
        className={`col-10 ` + (isApp && "mb-2")}
        style={
          data.type == "question"
            ? { marginLeft: "auto" }
            : { marginRight: "auto" }
        }
      >
        <div className="card" style={{ borderRadius: 10, boxShadow: "1px 1px 6px #ccc" }}>
          <div className={"card-body " + (isApp && "px-2 py-3")}>
            <div className={"entete " + (isApp && "border-bottom pb-2")}>
              <h5 className={(isApp && "nfs-12 mb-0")}>{data.type == "question" ? user.fullname : "پشتیبان"}</h5>
              <small className={(isApp && "nfs-10")}>{ToTimeJalali(data.created_at)}</small>
            </div>
            <h6 className={(isApp && "nfs-11 mt-3")}>{data.message}</h6>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Fragment>
      <div className="card">
        <div className="card-body">
          {state.loading ? (
            <Loading count={1} col={12} height={600} />
          ) : (
            <>
              <h4>{ }</h4>
              {state.data &&
                state.data.messages.map((messages, i) => {
                  return <UserChat data={messages} key={i} />;
                })}
              <div className="row mt-4 pt-4 align-items-end"
                style={{ borderTop: "2px solid", borderTopColor: "#ccc" }} >
                <div className={"form-group col-11 mb-0 " + (isApp && "col-12")}>
                  <label htmlFor="message">ارسال پیام جدید</label>
                  <input
                    id="message"
                    placeholder="توضیحات شما ..."
                    value={state.form.description}
                    onChange={e =>
                      setState({
                        ...state,
                        form: { ...state.form, description: e.target.value },
                      })
                    }
                    className=" form-control"
                  />
                </div>
                <div className={"col-1 " + (isApp && "col-12 mt-3")}>
                  {state.loadbtn ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Spinner
                        as="span"
                        animation="border"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                      />
                    </div>
                  ) : (
                    <button
                      disabled={state.loadbtn}
                      onClick={() => SendMessage()}
                      type="button"
                      className={"btn btn-success " + (isApp && "w-100")}
                    >
                      ارسال
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default Chating;
